document.addEventListener('DOMContentLoaded', function () {

  /* =========================================
     OFFER TIERS
     ========================================= */

  var TIERS = [
    {
      qty: 1,
      label: 'Buy 1 Get ₹50 Off',
      amount: 50
    },
    {
      qty: 2,
      label: 'Buy 2 Get ₹150 Off',
      amount: 150
    },
    {
      qty: 3,
      label: 'Buy 3 Get ₹200 Off',
      amount: 200
    }
  ];


  /* =========================================
     GET TOTAL CART QUANTITY
     ========================================= */

  function getCartQty() {

    var inputs = document.querySelectorAll(
      '#CartDrawer-CartItems input[name="updates[]"]'
    );

    var total = 0;

    inputs.forEach(function (input) {
      total += parseInt(input.value, 10) || 0;
    });

    return total;
  }


  /* =========================================
     GET PROGRESS %
     ========================================= */

  function getProgressPercent(qty) {

    var maxQty = TIERS[TIERS.length - 1].qty;

    if (qty <= 0) {
      return 0;
    }

    if (qty >= maxQty) {
      return 100;
    }

    return Math.round((qty / maxQty) * 100);
  }


  /* =========================================
     GET NEXT TIER
     ========================================= */

  function getNextTier(qty) {

    for (var i = 0; i < TIERS.length; i++) {

      if (qty < TIERS[i].qty) {
        return TIERS[i];
      }

    }

    return null;
  }


  /* =========================================
     GET CURRENT TIER
     ========================================= */

  function getCurrentTier(qty) {

    var currentTier = null;

    TIERS.forEach(function (tier) {

      if (qty >= tier.qty) {
        currentTier = tier;
      }

    });

    return currentTier;
  }


  /* =========================================
     BUILD PROGRESS BAR HTML
     ========================================= */

  function buildBarHTML(qty) {

    /*
     * If cart is empty, don't show progress bar.
     */

    if (qty <= 0) {
      return '';
    }


    var progress = getProgressPercent(qty);
    var nextTier = getNextTier(qty);


    /* -----------------------------------------
       BANNER TEXT
       ----------------------------------------- */

    var bannerText;

    if (nextTier) {

      var remaining = nextTier.qty - qty;

      bannerText =
        'Add ' +
        remaining +
        ' item' +
        (remaining > 1 ? 's' : '') +
        ' more to get ₹' +
        nextTier.amount +
        ' OFF!';

    } else {

      bannerText =
        '🎉 You\'ve unlocked the best offer: ₹' +
        TIERS[TIERS.length - 1].amount +
        ' OFF!';

    }


    /* -----------------------------------------
       TOP LABELS
       ----------------------------------------- */

    var tierLabels = TIERS.map(function (tier) {

      var unlocked = qty >= tier.qty;

      return (
        '<span class="cart-progress__tier-label ' +
        (unlocked ? 'unlocked' : '') +
        '">' +

        (unlocked
          ? '✓ UNLOCKED'
          : 'BUY ' + tier.qty) +

        '</span>'
      );

    }).join('');


    /* -----------------------------------------
       DISCOUNT BADGES
       ----------------------------------------- */

    var discountBadges = TIERS.map(function (tier) {

      var achieved = qty >= tier.qty;

      return (
        '<span class="cart-progress__discount ' +
        (achieved ? 'active' : '') +
        '">' +

        (achieved ? '★ ' : '') +

        '₹' +
        tier.amount +
        ' OFF' +

        (achieved ? ' ★' : '') +

        '</span>'
      );

    }).join('');


    /* -----------------------------------------
       MILESTONE DOTS
       ----------------------------------------- */

    var checkpoints = TIERS.map(function (tier) {

      var checkpointPercent =
        (tier.qty / TIERS[TIERS.length - 1].qty) * 100;

      var unlocked =
        qty >= tier.qty;

      return (
        '<span class="cart-progress__checkpoint ' +
        (unlocked ? 'active' : '') +
        '" ' +

        'style="left:' +
        checkpointPercent +
        '%">' +

        '</span>'
      );

    }).join('');


    /* -----------------------------------------
       CURRENT POSITION DOT
       ----------------------------------------- */

    var marker =
      '<span class="cart-progress__current-marker" ' +
      'style="left:' +
      progress +
      '%">' +
      '</span>';


    /* -----------------------------------------
       FINAL HTML
       ----------------------------------------- */

    return (

      '<div class="cart-progress-bar">' +

        '<div class="cart-progress__banner">' +
          bannerText +
        '</div>' +

        '<div class="cart-progress__tiers">' +
          tierLabels +
        '</div>' +

        '<div class="cart-progress__track-wrapper">' +

          '<div class="cart-progress__track">' +

            '<div class="cart-progress__fill" ' +
              'style="width:' +
              progress +
              '%">' +
            '</div>' +

            checkpoints +

            marker +

          '</div>' +

        '</div>' +

        '<div class="cart-progress__discounts">' +
          discountBadges +
        '</div>' +

        '<p class="cart-progress__note">' +
          '*Applicable on prepaid orders only' +
        '</p>' +

      '</div>'
    );
  }


  /* =========================================
     BUILD ITEM OFFER BADGE
     ========================================= */

  function buildLineItemBadge(qty) {

    var currentTier = getCurrentTier(qty);

    if (!currentTier) {
      return '';
    }

    return (

      '<div class="cart-item__discount-strip">' +

        '<span class="cart-item__discount-icon">' +
          '🏷️' +
        '</span> ' +

        currentTier.label +

      '</div>'
    );
  }


  /* =========================================
     RENDER PROGRESS BAR
     ========================================= */

  function renderBar() {

    var drawer =
      document.getElementById('CartDrawer');

    if (!drawer) {
      return;
    }


    var drawerInner =
      drawer.querySelector('.drawer__inner');

    var itemsEl =
      drawer.querySelector('cart-drawer-items');


    /*
     * Shopify may take a moment to recreate
     * these elements after cart update.
     */

    if (!drawerInner || !itemsEl) {
      return;
    }


    var qty = getCartQty();

    var html =
      buildBarHTML(qty);


    var existing =
      drawer.querySelector(
        '#cartProgressBarWrap'
      );


    /* -----------------------------------------
       PROGRESS BAR
       ----------------------------------------- */

    if (!html) {

      if (existing) {
        existing.remove();
      }

    } else {

      if (!existing) {

        existing =
          document.createElement('div');

        existing.id =
          'cartProgressBarWrap';

        /*
         * Insert immediately before cart items.
         */

        drawerInner.insertBefore(
          existing,
          itemsEl
        );

      }

      /*
       * Update contents.
       */

      existing.innerHTML = html;
    }


    /* -----------------------------------------
       ITEM BADGES
       ----------------------------------------- */

    var badgeHTML =
      buildLineItemBadge(qty);


    drawer
      .querySelectorAll(
        '.cart-item__quantity-wrapper'
      )
      .forEach(function (wrapper) {

        var parent =
          wrapper.parentElement;

        if (!parent) {
          return;
        }


        var strip =
          parent.querySelector(
            '.cart-item__discount-strip'
          );


        if (!badgeHTML) {

          if (strip) {
            strip.remove();
          }

          return;
        }


        if (!strip) {

          wrapper.insertAdjacentHTML(
            'afterend',
            badgeHTML
          );

        } else {

          strip.outerHTML =
            badgeHTML;

        }

      });
  }


  /* =========================================
     DELAYED RENDER
     ========================================= */

  var renderTimer = null;

  function scheduleRender(delay) {

    clearTimeout(renderTimer);

    renderTimer =
      setTimeout(function () {

        renderBar();

      }, delay || 100);
  }


  /* =========================================
     INITIAL RENDER
     ========================================= */

  scheduleRender(300);


  /* =========================================
     SHOPIFY CART EVENTS
     ========================================= */

  document.addEventListener(
    'cart:update',
    function () {

      /*
       * Shopify is still rebuilding the drawer
       * when this event fires.
       *
       * Give it a little time.
       */

      scheduleRender(150);

      /*
       * Second safety render.
       */

      setTimeout(function () {
        renderBar();
      }, 500);

    }
  );


  document.addEventListener(
    'cart:refresh',
    function () {

      scheduleRender(150);

      setTimeout(function () {
        renderBar();
      }, 500);

    }
  );


  /* =========================================
     MUTATION OBSERVER
     ========================================= */

  var cartDrawer =
    document.getElementById('CartDrawer');


  if (cartDrawer) {

    var observer =
      new MutationObserver(function (mutations) {

        var shouldRender = false;


        mutations.forEach(function (mutation) {

          /*
           * Check whether Shopify changed
           * the cart items / quantity area.
           */

          if (
            mutation.target.closest &&
            mutation.target.closest(
              'cart-drawer-items'
            )
          ) {

            shouldRender = true;

          }


          /*
           * Check added/removed Shopify cart nodes.
           */

          if (
            mutation.addedNodes &&
            mutation.addedNodes.length
          ) {

            mutation.addedNodes.forEach(
              function (node) {

                if (
                  node.nodeType === 1 &&
                  (
                    node.matches?.(
                      'cart-drawer-items'
                    ) ||
                    node.querySelector?.(
                      'cart-drawer-items'
                    )
                  )
                ) {

                  shouldRender = true;

                }

              }
            );

          }

        });


        if (shouldRender) {
          scheduleRender(120);
        }

      });


    observer.observe(
      cartDrawer,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* =========================================
     DIRECT QUANTITY CHANGE
     ========================================= */

  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.matches &&
        event.target.matches(
          '#CartDrawer-CartItems input[name="updates[]"]'
        )
      ) {

        scheduleRender(100);

      }

    }
  );


  /* =========================================
     PLUS / MINUS CLICK
     ========================================= */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest?.(
          '#CartDrawer-CartItems button'
        );


      if (button) {

        /*
         * First render quickly.
         */

        scheduleRender(100);


        /*
         * Shopify may replace the drawer
         * slightly later.
         */

        setTimeout(function () {
          renderBar();
        }, 400);

      }

    }
  );

});